"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationsReducer = void 0;

var _actions = require("./actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getDefaultState = function getDefaultState() {
  return {
    active: [],
    history: [],
    historyLimit: 50
  };
};

var historyPush = function historyPush() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var notifications = arguments.length > 1 ? arguments[1] : undefined;

  // Add the new notifications to the list of notifications, and then truncate the array after history limit number of items.
  var newState = _toConsumableArray(state.history).concat(notifications);

  return newState.sort(function (p, p2) {
    return p2.time - p.time;
  }).slice(0, state.historyLimit);
};

var notificationsReducer = function notificationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case _actions.NOTIFICATION_PUSH:
      {
        var notifications = payload.notification;
        return _objectSpread(_objectSpread({}, state), {}, {
          active: _toConsumableArray(state.active).concat(notifications).sort(function (p, p2) {
            return p2.time - p.time;
          }),
          history: historyPush(state, notifications)
        });
      }

    case _actions.NOTIFICATION_REMOVE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          active: _toConsumableArray(state.active).filter(function (notification) {
            return notification.id !== payload.id;
          })
        });
      }

    case _actions.NOTIFICATIONS_CLEAR_BY_NAMESPACE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          active: state.active.filter(function (notification) {
            return notification.namespace !== payload.namespace;
          })
        });
      }

    case _actions.NOTIFICATIONS_CLEAR_BY_NAMESPACES:
      {
        // get object like this { namespace: true, namespace2: true} to decrease algorithm complexity
        var namespacesToFilter = payload.namespaces.reduce(function (partial, n) {
          return partial[n] = true, partial;
        }, {}); // eslint-disable-line

        return _objectSpread(_objectSpread({}, state), {}, {
          active: state.active.filter(function (notification) {
            return !namespacesToFilter[notification.namespace];
          })
        });
      }

    case _actions.NOTIFICATIONS_CLEAR_ALL_POSSIBLE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          active: state.active.filter(function (notification) {
            return !notification.notificationParams.closeButton;
          })
        });
      }

    case _actions.NOTIFICATIONS_CLEAR_ARCHIVED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          history: _toConsumableArray(state.active) // Setting the history to active effectively removes the active only notifications

        });
      }

    case _actions.SET_HISTORY_NOTIFICATIONS_LIMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        historyLimit: payload.limit
      });

    case _actions.LOAD_HISTORY_NOTIFICATIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        history: payload.history
      });

    default:
      return state;
  }
};

exports.notificationsReducer = notificationsReducer;
//# sourceMappingURL=notifications-reducer.js.map